import { forwardRef } from 'react'
import Input from './Input'
const Textarea = forwardRef(function Textarea({ className = '', ...props }, ref) {
    return <Input {...props} ref={ref} as="textarea" className={'uiTextarea ' + className} />
})
Textarea.uiField = true
export default Textarea
